import { Component } from '@angular/core';

@Component({
  selector: 'app-footer',
  templateUrl: './app-footer.component.html'
})
export class AppFooterComponent {
  data = new Date();
  ano  = this.data.getFullYear();
 }



// WEBPACK FOOTER //
// ./src/app/shared/app-footer/app-footer.component.ts